import { combineReducers } from 'redux';

import MyLibraryHome from './containers/MylibraryHome';
import ContentPreview from './containers/ContentPreview';
import ContentCreate from './containers/ContentCreate';

import contentTypeReducers from './reducers/contentTypeReducers';
import contentSubtypeReducers from './reducers/contentSubtypeReducers';
import contentTagsReducers from './reducers/contentTagsReducers';
import classesReducers from './reducers/classesReducers';
import contentStatusReducers from './reducers/contentStatusReducers';
import contentReducers from './reducers/contentReducers';
import filterUserReducer from './reducers/filterUserReducer';
import userReducers from './reducers/userReducers';
import courseReducers from './reducers/courseReducers';
import { contentInSectionReducers } from './reducers/contentInSectionReducers';
import { contentInParaghSectionReducers } from './reducers/contentInParagraphReducers';
import commentReducer from './reducers/commentReducer'
import syllabusReducers from './reducers/syllabusReducers';





const reducers = combineReducers({
  contentType: contentTypeReducers,
  contentSubtype: contentSubtypeReducers,
  contentStatus: contentStatusReducers,
  contentTags: contentTagsReducers,
  classes: classesReducers,
  content: contentReducers,
  courses: courseReducers,
  filterByUser: filterUserReducer,
  contentInSection: contentInSectionReducers,
  contentInParagraphSection: contentInParaghSectionReducers,
  users: userReducers,
  comment: commentReducer,
  syllabus: syllabusReducers
});

const components = { MyLibraryHome, ContentPreview, ContentCreate };

export { components, reducers };